<template>
    <div class="filter-window">
        <div class="filter-window__title-wrapper">
            <div class="filter-window__title" >{{ title }}</div>
            <icon class="filter-window__icon-close" icon="close" :width="22" :height="22" @click.native="toggleFilter"/>
        </div>
        <slot></slot>
        <v-layout row class="buttons">
            <v-flex>
                <sp-btn @click.native="onResetFilters()" text="Reset" icon="reset"></sp-btn>
            </v-flex>
            <v-flex class="right text-xs-right">
                <sp-btn @click.native="onApplyFilters()" text="Apply" icon="download"></sp-btn>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/atoms/Icon'
import SpBtn from '@/components/forms/SpBtn'

export default {
    name: 'ResourceFilterLayout',
    components: {
        Icon,
        SpBtn,
    },
    props: {
        title: {
            type: String
        },
        type: {
            type: [String],
            required: true,
        }
    },
    computed: {
        ...mapGetters('filterModule', {
            getIsFilterActive: 'getIsFilterActive'
        })
    },
    methods: {
        ...mapActions('filterModule', {
            setIsFilterActive: 'setIsFilterActive'
        }),
        toggleFilter () {
            this.setIsFilterActive(!this.getIsFilterActive)
        },
        closeFilter () {
            this.setIsFilterActive(false)
        },
        onApplyFilters () {
            this.$emit('applyFilters', this.type);
            this.closeFilter()
        },
        onResetFilters () {
            this.$emit('resetFilters', this.type);
            this.closeFilter()
        }
    }
}
</script>

<style scoped lang="scss">

.filter-window {
    position: absolute;
    right: 0px;
    top: 0px;
    padding: 20px 10px;
    z-index: 1;
    background-color: #f1f6f6;
    height: 100%;
    box-shadow: 0 4px 212px 0 rgba(0, 0, 0, 0.45);
    width: 95%;
    overflow-y: scroll;

    &__title-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__title {
        font-weight: 700;
        font-size: 16px;
    }

    &__icon-close {
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
            opacity: 0.5;
        }
    }

    &__btn-wrapper {
        display: flex;
        justify-content: space-between;
    }

    &__btn {
        width: max-content;
        font-weight: 700;
        height: max-content !important;
        padding: 10px 15px !important;
        font-size: 12px;
        color: #fff;
        text-transform: inherit;

        &--reset {
            background-color: #ffae2b !important;
        }

        &--apply {
            background-color: #00ab00 !important;
        }
    }
}
</style>
